import styled from 'styled-components';
import { createShouldForwardStyledProp } from '../../styles';
import type { FormControlProps } from '../Form';
import { formControlCSS } from '../Form/styles';

export const TimePickerInputWrapper = styled.label.withConfig({
  shouldForwardProp: createShouldForwardStyledProp(['prefix']),
})<FormControlProps<HTMLInputElement>>`
  ${formControlCSS}
  gap: 0;
  display: flex;
  justify-content: center;
  width: 100%;

  input {
    text-align: center !important;
    width: fit-content;
    flex: 0 0 auto;
  }
`;

export const Delimiter = styled.span``;

export const PrecisionWrapper = styled.div`
  display: flex;
  width: fit-content;

  &:last-child input {
    width: 24px;
  }
`;
